import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { FieldsetModule } from 'primeng/fieldset';
import { InputTextarea } from 'primeng/inputtextarea';
import { TooltipModule } from 'primeng/tooltip';
import { MAX_OBSERVACION_NOTIFICACION } from 'src/app/common/constants-ejb';
import { sanitizeTextarea } from 'src/app/common/input-utils';
import { ContadorCaracteresDirective } from 'src/app/presentation/shared/contador-caracteres/contador-caracteres.directive';

/**
 * DUMB COMPONENT: SeccionNotificacion
 *
 * Observación que se incluye en el correo al contacto cuando se ingresa un cumplimiento Sin OC de línea de
 * atención (forma de entrega distinta de DOMICILIO y SKYPE_EMPRESARIAL).
 *
 * Legacy: CreateOrUpdateCumplimientoViewImpl.ui.xml panelNotificacion + taObsNotifica. En el legado el campo
 * muestra `*` pero no es obligatorio (`setRequired` está comentado, ViewImpl:2638), por eso aquí tampoco lo es.
 * El legado también tenía un adjunto; se retiró por decisión del equipo (los correos no llevan adjuntos).
 */
@Component({
  selector: 'app-seccion-notificacion',
  standalone: true,
  imports: [
    ContadorCaracteresDirective,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FieldsetModule,
    InputTextarea,
    TooltipModule
  ],
  template: `
    <p-fieldset legend="Notificación al contacto" [toggleable]="true" styleClass="mb-4">
      <div [formGroup]="form()">
        <label for="observacionNotificacion" class="block text-sm font-medium text-gray-700 mb-1">
          Observación de la notificación
        </label>
        <textarea
          id="observacionNotificacion"
          pInputTextarea
          formControlName="observacionNotificacion"
          rows="4"
          class="w-full"
          [appContadorCaracteres]="maxObservacionNotificacion"
          (change)="sanitizar()"
          pTooltip="Esta observación se envía por correo al contacto"
          aria-describedby="ayudaObservacionNotificacion"
        >
        </textarea>
        <small id="ayudaObservacionNotificacion" class="block text-xs text-gray-600 mt-1">
          Se envía por correo al contacto. Evite símbolos especiales como &lt; &gt; &amp; &#64; $ =
        </small>
      </div>
    </p-fieldset>
  `
})
export class SeccionNotificacionComponent {
  readonly maxObservacionNotificacion = MAX_OBSERVACION_NOTIFICACION;
  form = input.required<FormGroup>();

  /** Defensa en profundidad (seguridad-girop §3): el backend valida con @SafeText y responde 400. */
  sanitizar(): void {
    const control = this.form().get('observacionNotificacion');
    const actual = control?.value as string | null | undefined;
    const limpio = sanitizeTextarea(actual);
    if (control && limpio !== (actual ?? '')) {
      control.setValue(limpio);
    }
  }
}
